"use strict";
/**
 * IATA → GPS coordinate lookup for Transit class `locations[]` geofence.
 *
 * Static, embedded list of ~150 of the busiest European + global hub
 * airports. When an airport isn't here, we silently skip the geofence
 * (the pass still works; it just won't surface on lockscreen near that
 * specific airport). Picking up new airports is a one-line table edit.
 *
 * Coordinates are WGS84 decimal degrees, sourced from public
 * OpenFlights data — standard precision is fine for Wallet's ~100m
 * lockscreen-trigger radius.
 *
 * Promotion to a DB-backed table later is one query change away if the
 * partner footprint grows past hardcoded.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.lookupAirportGps = lookupAirportGps;
exports.buildAirportLocations = buildAirportLocations;
const TABLE = {
    // Hungary + neighbours (demo focus)
    BUD: { lat: 47.4297, lng: 19.2611 },
    VIE: { lat: 48.1103, lng: 16.5697 },
    PRG: { lat: 50.1008, lng: 14.26 },
    KSC: { lat: 48.6631, lng: 21.2411 },
    WAW: { lat: 52.1657, lng: 20.9671 },
    KRK: { lat: 50.0777, lng: 19.7848 },
    OTP: { lat: 44.5711, lng: 26.085 },
    ZAG: { lat: 45.7429, lng: 16.0688 },
    SOF: { lat: 42.6952, lng: 23.4114 },
    BEG: { lat: 44.8184, lng: 20.3091 },
    // German-speaking + Benelux
    FRA: { lat: 50.0379, lng: 8.5622 },
    MUC: { lat: 48.3537, lng: 11.775 },
    TXL: { lat: 52.5597, lng: 13.2877 },
    BER: { lat: 52.3667, lng: 13.5033 },
    HAM: { lat: 53.6304, lng: 9.9882 },
    DUS: { lat: 51.2895, lng: 6.7668 },
    STR: { lat: 48.6899, lng: 9.2219 },
    ZRH: { lat: 47.4647, lng: 8.5492 },
    GVA: { lat: 46.2381, lng: 6.1089 },
    AMS: { lat: 52.3086, lng: 4.7639 },
    BRU: { lat: 50.9014, lng: 4.4844 },
    LUX: { lat: 49.6266, lng: 6.2115 },
    // UK / Ireland
    LHR: { lat: 51.4706, lng: -0.4619 },
    LGW: { lat: 51.1481, lng: -0.1903 },
    STN: { lat: 51.885, lng: 0.235 },
    LTN: { lat: 51.8747, lng: -0.3683 },
    LCY: { lat: 51.5053, lng: 0.0553 },
    MAN: { lat: 53.3537, lng: -2.275 },
    EDI: { lat: 55.95, lng: -3.3725 },
    DUB: { lat: 53.4213, lng: -6.27 },
    // France / Iberia / Italy
    CDG: { lat: 49.0097, lng: 2.5479 },
    ORY: { lat: 48.7233, lng: 2.3794 },
    NCE: { lat: 43.6584, lng: 7.2159 },
    LYS: { lat: 45.7256, lng: 5.0811 },
    MRS: { lat: 43.4365, lng: 5.215 },
    MAD: { lat: 40.4936, lng: -3.5668 },
    BCN: { lat: 41.2974, lng: 2.0833 },
    AGP: { lat: 36.6749, lng: -4.4991 },
    PMI: { lat: 39.5517, lng: 2.7388 },
    LIS: { lat: 38.7813, lng: -9.1359 },
    OPO: { lat: 41.2481, lng: -8.6814 },
    FCO: { lat: 41.8003, lng: 12.2389 },
    CIA: { lat: 41.7994, lng: 12.5949 },
    MXP: { lat: 45.6306, lng: 8.7281 },
    LIN: { lat: 45.4451, lng: 9.2767 },
    BGY: { lat: 45.6739, lng: 9.7042 },
    VCE: { lat: 45.5053, lng: 12.3519 },
    NAP: { lat: 40.886, lng: 14.2908 },
    CTA: { lat: 37.4668, lng: 15.0664 },
    PMO: { lat: 38.1759, lng: 13.091 },
    BLQ: { lat: 44.5354, lng: 11.2887 },
    // Nordics + Baltics
    CPH: { lat: 55.6181, lng: 12.6561 },
    ARN: { lat: 59.6519, lng: 17.9186 },
    GOT: { lat: 57.6628, lng: 12.2798 },
    OSL: { lat: 60.1939, lng: 11.1004 },
    TRD: { lat: 63.4578, lng: 10.924 },
    HEL: { lat: 60.3172, lng: 24.9633 },
    RIX: { lat: 56.9236, lng: 23.9711 },
    TLL: { lat: 59.4133, lng: 24.8328 },
    VNO: { lat: 54.6341, lng: 25.2858 },
    // SE / Greece / Cyprus / Turkey
    ATH: { lat: 37.9364, lng: 23.9445 },
    SKG: { lat: 40.5197, lng: 22.9709 },
    HER: { lat: 35.3397, lng: 25.1803 },
    RHO: { lat: 36.4054, lng: 28.0862 },
    LCA: { lat: 34.875, lng: 33.6249 },
    IST: { lat: 41.2753, lng: 28.7519 },
    SAW: { lat: 40.8986, lng: 29.3092 },
    AYT: { lat: 36.8987, lng: 30.8005 },
    // Middle East
    DXB: { lat: 25.2528, lng: 55.3644 },
    AUH: { lat: 24.4331, lng: 54.6511 },
    DOH: { lat: 25.2731, lng: 51.6086 },
    TLV: { lat: 32.0114, lng: 34.8867 },
    // North America
    JFK: { lat: 40.6398, lng: -73.7789 },
    EWR: { lat: 40.6925, lng: -74.1687 },
    LGA: { lat: 40.7773, lng: -73.8726 },
    BOS: { lat: 42.3656, lng: -71.0096 },
    IAD: { lat: 38.9531, lng: -77.4565 },
    DCA: { lat: 38.8521, lng: -77.0377 },
    ORD: { lat: 41.9786, lng: -87.9047 },
    ATL: { lat: 33.6367, lng: -84.4281 },
    MIA: { lat: 25.7959, lng: -80.287 },
    LAX: { lat: 33.9425, lng: -118.4081 },
    SFO: { lat: 37.6188, lng: -122.3754 },
    SEA: { lat: 47.4502, lng: -122.3088 },
    YYZ: { lat: 43.6772, lng: -79.6306 },
    YUL: { lat: 45.4706, lng: -73.7408 },
    YVR: { lat: 49.1939, lng: -123.1844 },
    // Asia
    HND: { lat: 35.5494, lng: 139.7798 },
    NRT: { lat: 35.7647, lng: 140.3864 },
    ICN: { lat: 37.4602, lng: 126.4407 },
    PEK: { lat: 40.0801, lng: 116.5847 },
    PVG: { lat: 31.1443, lng: 121.8083 },
    HKG: { lat: 22.308, lng: 113.9185 },
    SIN: { lat: 1.3644, lng: 103.9915 },
    BKK: { lat: 13.69, lng: 100.7501 },
    KUL: { lat: 2.7456, lng: 101.7099 },
};
/** Returns lat/lng for an IATA code if known; null otherwise. */
function lookupAirportGps(iata) {
    if (!iata)
        return null;
    return TABLE[iata.toUpperCase()] ?? null;
}
/**
 * Build the `locations[]` array for a Transit object — one entry per
 * known airport. Returns empty array when neither end is known (never
 * undefined, since callers may want to assert presence).
 */
function buildAirportLocations(origin, destination) {
    const out = [];
    const o = origin ? lookupAirportGps(origin) : null;
    if (o)
        out.push({ latitude: o.lat, longitude: o.lng });
    const d = destination ? lookupAirportGps(destination) : null;
    if (d)
        out.push({ latitude: d.lat, longitude: d.lng });
    return out;
}
//# sourceMappingURL=airportLocations.js.map